import React from "react"
import { Field } from "../../field"
import { FieldWithSubText } from "./field-with-subtext"
import { AddressFieldWithHiddenInputs } from "./address-field-with-hidden-inputs"
import { CheckboxesForCompetitionMarketingForm } from "./checkboxes-for-competition-marketing-form"
import { PrivacyPolicyLink } from "./privacy-policy-link"
import { StepFieldsProps } from "../../../types/cms/competition-marketing-form"

export const StepFields = (props: StepFieldsProps) => {
  const {
    fieldName,
    fields,
    form,
    formCheckboxes,
    showTermsAndConditionsLink,
    applyAddressToFormMarketing,
    stepContent,
    subText,
    label
  } = props

  switch (fieldName) {
    case 'question1':
    case 'question2':
    case 'question3':
      return (
        <FieldWithSubText
          label={label}
          subText={subText}
          hasError={!!form.formState.errors[fieldName]}
        >
          <Field {...fields[fieldName]} type='textarea' showAsterisk inputGroupProps={{ style: {maxWidth: 450} }} inputProps={{style: { padding: '10px', resize: 'none'}}} />
        </FieldWithSubText>
      )

    case 'firstname':
      return <Field {...fields.firstName} showAsterisk inputGroupProps={{ style: { maxWidth: 450 } }} />

    case 'lastname':
      return (
        <FieldWithSubText
          subText={stepContent?.stepperFormSubtext?.nameFieldSubtext}
          hasError={!!form.formState.errors.lastname}
        >
          <Field {...fields.lastName} showAsterisk inputGroupProps={{ style: { maxWidth: 450 } }} />
        </FieldWithSubText>
      )

    case 'email':
      return (
        <FieldWithSubText
          subText={stepContent?.stepperFormSubtext?.emailFieldSubtext}
          hasError={!!form.formState.errors.email}
        >
          <Field {...fields.email} showAsterisk inputGroupProps={{ style: { maxWidth: 450 } }} />
        </FieldWithSubText>
      )

    case 'phone':
      return (
        <FieldWithSubText
          subText={stepContent?.stepperFormSubtext?.phoneFieldSubtext}
          hasError={!!form.formState.errors.phone}
        >
          <Field {...fields.phone} showAsterisk inputGroupProps={{ style: { maxWidth: 450 } }} />
        </FieldWithSubText>
      )

    case 'address':
      return (
        <AddressFieldWithHiddenInputs
          field={fields.address}
          form={form}
          applyAddressToFormMarketing={applyAddressToFormMarketing}
          hasError={!!form.formState.errors.address}
          subtext={stepContent?.stepperFormSubtext?.addressFieldSubtext}
        />
      )

    case 'checkboxes':
      return (
        <>
          <CheckboxesForCompetitionMarketingForm
            form={form}
            formCheckboxes={formCheckboxes}
          />
          {showTermsAndConditionsLink && <PrivacyPolicyLink />}
        </>
      )

    default:
      return null
  }
}